import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CashAndBlockSummaryReport } from './Pages/listing';

export const CashAndBlockSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CashAndBlockSummaryReport} />
    </Fragment>
)